import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "el-form-w3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form_item = _resolveComponent("el-form-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form_item, null, {
    default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("h4", null, "宽", -1)), _createVNode(_component_el_input_number, {
      modelValue: _ctx.inputNumber,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.inputNumber = $event),
      "controls-position": "right"
    }, null, 8, ["modelValue"]), _cache[3] || (_cache[3] = _createElementVNode("span", {
      class: "unit"
    }, "px", -1))]),
    _: 1,
    __: [2, 3]
  }), _cache[6] || (_cache[6] = _createElementVNode("span", {
    class: "icon-link"
  }, null, -1)), _createVNode(_component_el_form_item, null, {
    default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("h4", null, "高", -1)), _createVNode(_component_el_input_number, {
      modelValue: _ctx.inputNumber,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.inputNumber = $event),
      "controls-position": "right"
    }, null, 8, ["modelValue"]), _cache[5] || (_cache[5] = _createElementVNode("span", {
      class: "unit"
    }, "px", -1))]),
    _: 1,
    __: [4, 5]
  })]);
}